// amplify-config.ts
import { Amplify } from 'aws-amplify';

export interface AmplifyConfig {
  appsyncUrl: string;
  appsyncRegion: string;
  cognitoUserPoolId: string;
  cognitoUserPoolClientId: string;
  cognitoIdentityPoolId: string;
}

export const configureAmplify = (customConfig?: Partial<AmplifyConfig>) => {
  const region = customConfig?.appsyncRegion || import.meta.env.VITE_AWS_REGION;
  const userPoolId = customConfig?.cognitoUserPoolId || import.meta.env.VITE_COGNITO_USER_POOL_ID;
  const userPoolWebClientId = customConfig?.cognitoUserPoolClientId || import.meta.env.VITE_COGNITO_CLIENT_ID;
  const identityPoolId = customConfig?.cognitoIdentityPoolId || import.meta.env.VITE_COGNITO_IDENTITY_POOL_ID;
  const appsyncUrl = customConfig?.appsyncUrl || import.meta.env.VITE_APPSYNC_URL;

  if (!region || !userPoolId || !userPoolWebClientId) {
    console.error("CRITICAL: One or more Amplify environment variables are undefined!");
    throw new Error("Amplify configuration missing environment variables (check .env file and VITE_ prefixes).");
  }

  const amplifyConfig: any = {
    Auth: {
      Cognito: {
        userPoolId: userPoolId,
        userPoolClientId: userPoolWebClientId,
        identityPoolId: identityPoolId,
      }
    }
  };

  // Add AppSync/API configuration if URL is provided
  if (appsyncUrl) {
    amplifyConfig.API = {
      GraphQL: {
        endpoint: appsyncUrl,
        region: region,
        defaultAuthMode: 'userPool',
      }
    };
    console.log('AppSync API configured:', appsyncUrl);
  }

  Amplify.configure(amplifyConfig);
  console.log('Amplify configured successfully.');
};

export const configureAmplifyFromEnv = () => {
  configureAmplify({
    appsyncUrl: import.meta.env.VITE_APPSYNC_URL,
    appsyncRegion: import.meta.env.VITE_AWS_REGION,
    cognitoUserPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID,
    cognitoUserPoolClientId: import.meta.env.VITE_COGNITO_CLIENT_ID,
    cognitoIdentityPoolId: import.meta.env.VITE_COGNITO_IDENTITY_POOL_ID,
  });
};